"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Home = /*#__PURE__*/function () {
  function Home(client) {
    (0, _classCallCheck2["default"])(this, Home);
    this.client = client;
    this.resourceUrl = '/admin';
  }

  (0, _createClass2["default"])(Home, [{
    key: "getUserInfo",
    value: function getUserInfo() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.client.get("".concat(this.resourceUrl, "/count"), args);
    }
  }]);
  return Home;
}();

exports["default"] = Home;